import Vue from 'vue'
/*import Vant, { Locale } from 'vant'
import 'vant/lib/index.css'

Vue.use(Vant)*/
import {
    Button,
    Step,
    Steps,
    Col,
    Row,
    Toast,
    Dialog,
    Tab,
    Tabs,
    NoticeBar,
    Icon,
    Cell,
    CellGroup,
    List,
    CountDown, Notify
} from 'vant'
Vue.use(CountDown)
Vue.use(Tab);
Vue.use(Tabs);

Vue.use(Dialog)
Vue.use(Toast)
Vue.use(Col);
Vue.use(Row);
Vue.use(Button)
Vue.use(Step);
Vue.use(Steps);
Vue.use(NoticeBar)
Vue.use(Icon)
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(List)
Vue.use(Notify)